import React from "react";
import "./mainpage.css";
import Header from "../features/Header";
import Footer from "../features/Footer";
import { Link } from "react-router-dom";

const MainPage = () => {
  return (
    <>
      <div className="page-container">
        <Header />
        <main>
          <div className="content-wrap">
            <div className="main-wrapper">
              <section className="hero">
                <h1>АвтоГід — твій помічник у світі автомобілів</h1>
                <p>
                  Інформаційно-довідковий сервіс для тих, хто шукає, порівнює
                  або вивчає автомобілі. Зручно. Швидко. Сучасно.
                </p>
                <Link to="/catalog" className="hero-btn">
                  Перейти до каталогу
                </Link>
              </section>

              <section className="categories">
                <h2>Популярні категорії</h2>
                <div className="category-grid">
                  <div className="category-card">🚗 Седани</div>
                  <div className="category-card">🚙 Кросовери</div>
                  <div className="category-card">🚐 Мінівени</div>
                  <div className="category-card">🏎️ Спорткари</div>
                  <div className="category-card">🛻 Позашляховики</div>
                </div>
              </section>

              <section className="about">
                <h2>Що вміє наш сервіс?</h2>
                <ul>
                  <li>🔍 Фільтрація за маркою, типом та роком випуску</li>
                  <li>📄 Перегляд детальної інформації про авто</li>
                  <li>⭐ Обране та збережені авто (в розробці)</li>
                  <li>📈 Статистика, рейтинги, популярні моделі</li>
                </ul>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default MainPage;
